import {BTDataLayer} from './datalayer';
import BTCookies from '../common/cookies';


function initConversionPixel({
  statsUrl,
  baseDomain,
  sessionCookieName = 'bt-conv',
  agentCookieName = 'bt',
  btDataLayer = 'btDataLayer',
  globalFunctionName = null,
  fallbackSessionId = null,
  fallbackAgentId = null,
}) {
  const dataLayer = new BTDataLayer(
    {
      cookieManager: BTCookies,
      baseDomain,
      trackerUrl: statsUrl,
      sessionCookieName,
      agentCookieName,
      initialDataLayer: window[btDataLayer] || [],
      sessionTimeoutMinutes: 240,
      fallbackSessionId,
      fallbackAgentId,
    },
  );

  window[btDataLayer] = dataLayer;

  if (globalFunctionName) {
    window[globalFunctionName] = (action, id, payload) => {
      /* eslint-disable no-param-reassign */
      if (typeof (payload) === 'undefined') {
        payload = id;
        id = null;
      }
      /* eslint-enable no-param-reassign */

      window[btDataLayer].push({Action: action, Id: id, Payload: payload});
    };
  }

  return {sessionId: dataLayer.sessionId, agentId: dataLayer.agentId};
}


export {initConversionPixel};
